export enum RouterPath {
    ROOT = '/',
    HOME = '/home',
    AUTH_LOGIN = '/login',
    AUTH_CALLBACK = '/callback',
    AUTH_LOGOUT = '/logout',
    AUTH_SWITCH_WORKSPACE = '/switch-workspace',
    PAGE_USERS = '/permissoes',
    PAGE_REGISTER_USER = '/convidar',
    PAGE_INVOICE = '/faturas',
    PAGE_EXTRACT = '/extrato-vendas',
    ERROR_404 = '/error-404',
    ERROR = '/error',
    ERROR_WORKSPACE = '/error-workspace',
    DASHBOARD = '/relatorio',
    DASHBOARD_DETAILS = '/relatorio-detalhes'
}
